/* eslint-disable no-restricted-imports */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { loadTranslations } from './translations'
import { FlectoLanguages } from './types/FlectoLanguages'

i18n.use(initReactI18next).init({
  lng: FlectoLanguages.DEFAULT,
  resources: loadTranslations(),
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
